/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Empathy_Social_Sensitivity24Inputs */

const en_job_form_enum_empathy_social_sensitivity24 = /** @type {(inputs: Job_Form_Enum_Empathy_Social_Sensitivity24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empathy and Social Sensitivity`)
};

const de_job_form_enum_empathy_social_sensitivity24 = /** @type {(inputs: Job_Form_Enum_Empathy_Social_Sensitivity24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empathie und soziale Sensibilität`)
};

/**
* | output |
* | --- |
* | "Empathy and Social Sensitivity" |
*
* @param {Job_Form_Enum_Empathy_Social_Sensitivity24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_empathy_social_sensitivity24 = /** @type {((inputs?: Job_Form_Enum_Empathy_Social_Sensitivity24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Empathy_Social_Sensitivity24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_empathy_social_sensitivity24(inputs)
	return en_job_form_enum_empathy_social_sensitivity24(inputs)
});
export { job_form_enum_empathy_social_sensitivity24 as "job_form_enum_EMPATHY_SOCIAL_SENSITIVITY" }